import { Component, OnInit, Input } from '@angular/core';
import { Schedule } from '../../models/schedule';
import { ScheduleStateService } from '../../services/schedule-state.service';

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.css']
})
export class ScheduleListComponent implements OnInit {

  constructor(
    private scheduleStateService: ScheduleStateService,
  ) { }

  ngOnInit() {
    this.scheduleStateService.initialize().subscribe();
  }

  get allSchedules(): Schedule[] {
    return this.scheduleStateService.allSchedules;
  }

}
